import { CorporateAddressApi } from '@blank/api'

export const formatAddress = (
  address: Partial<CorporateAddressApi> | undefined
) => {
  return `${address?.street || ''}, ${address?.zipCode || ''} ${
    address?.city || ''
  }`
}
